import { cn } from "@/lib/utils"
import { normalizeRole } from "@/constants/roles"
import { USER_ROLE_DISPLAY_NAMES } from "@/types/User"

/**
 * Story 24.24b — the one role badge (DESIGN.md › Badges › badge-role): an
 * `active-wash` pill with the sentence-case role name, never the raw slug.
 * The role is resolved through `normalizeRole`, so a legacy or unknown claim
 * reads as the role the app actually treats it as. One per person, never
 * repeated on a page.
 */
function RoleBadge({ role, className }: { role: string | null | undefined; className?: string }) {
  return (
    <span
      data-slot="role-badge"
      className={cn("inline-flex rounded-full bg-active-wash text-active-wash-ink type-caption px-2", className)}
    >
      {USER_ROLE_DISPLAY_NAMES[normalizeRole(role)]}
    </span>
  )
}

export { RoleBadge }
